/* ==========================================================================
   Customer reviews — Loox or hand-picked reviews as our own cards.

   Hand-picked mode: the cards come from the section's Review blocks, already
   rendered by Liquid; this file only fits photos and wires Read more/arrows.

   Loox mode reads Loox's public review feed (what its "snippets" widget loads):
     https://loox.io/widget/<id>/snippets/reviews?limit=10&reviewsType=…
   → { reviews: [{ id, rating, text, name, image?, altText? }] }
   It caps at 10 and has no paging. It's undocumented, so every failure path
   (network error, unexpected shape, no reviews) hides the section instead of
   leaving placeholder cards up. Review text is inserted as text, never HTML.
   ========================================================================== */
(function () {
  var CACHE_PREFIX = 'fbLooxReviews:';

  function photoUrl(src) {
    if (!src) return '';
    // The feed hands out tiny thumbnails; Loox serves a ~600px "_mid" of
    // every photo at the same path, which is what its own feed uses.
    var url = src.replace(/_cf_tiny(\.\w+)$/, '_mid$1');
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  // "Customer photo review of C8 ZR1X Detailed Silhouette Metal Wall Art" →
  // the product title (video reviews say "video review" instead).
  function productName(alt, trim) {
    if (!alt) return '';
    var name = alt.replace(/^Customer (photo|video) review of\s+/i, '');
    (trim || '').split(',').forEach(function (phrase) {
      phrase = phrase.trim();
      if (phrase) name = name.split(phrase).join('');
    });
    return name.replace(/\s+/g, ' ').trim();
  }

  // Video reviews are left out: the feed only carries their thumbnail (with a
  // play icon baked in) and Loox doesn't expose the video itself to other
  // sites, so they can't play here. The alt text is the only reliable sign —
  // photo thumbnails share the same _cf_tiny file naming.
  function isVideoReview(r) {
    return /\bvideo review\b/i.test(r.altText || '');
  }

  function stars(rating) {
    var wrap = document.createElement('span');
    wrap.className = 'fb-rv-stars';
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', 'Rated ' + rating + ' out of 5');
    for (var i = 1; i <= 5; i++) {
      var s = document.createElement('span');
      s.textContent = '★';
      if (i > Math.round(rating)) s.className = 'is-off';
      wrap.appendChild(s);
    }
    return wrap;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  // Customer photos come in every shape. Once a photo loads, its frame takes
  // the photo's own proportions, kept between 3:4 (tall phone shots) and 4:3
  // (landscape), so most show uncropped and only panoramas lose a little at
  // the sides. Square until then. Cards aren't stretched to match, so each
  // ends where its content does.
  function fitPhoto(photo, img, done) {
    var apply = function () {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var ratio = Math.max(0.75, Math.min(4 / 3, img.naturalWidth / img.naturalHeight));
      photo.style.aspectRatio = String(ratio);
      if (done) done();
    };
    if (img.complete) apply();
    else img.addEventListener('load', apply);
  }

  function initReviews() { document.querySelectorAll('[data-fb-reviews]').forEach(function (root) {
    if (root.dataset.fbReady) return;
    root.dataset.fbReady = '1';

    var d = root.dataset;
    var manual = d.mode === 'manual';
    var track = root.querySelector('[data-fb-rv-track]');
    var prev = root.querySelector('[data-fb-rv-prev]');
    var next = root.querySelector('[data-fb-rv-next]');
    var arrows = root.querySelector('.fb-rv-arrows');
    var limit = Math.max(1, Math.min(10, parseInt(d.limit, 10) || 10));
    var isStore = d.source === 'store';
    var photosOnly = d.photosOnly === 'true' && !isStore;
    if (!track) return;

    var fail = function (why) {
      // In the theme editor, say what's wrong instead of vanishing.
      if (d.designMode === 'true') {
        track.innerHTML = '';
        track.appendChild(el('p', 'fb-rv-empty', manual
          ? 'No hand-picked reviews yet. Add "Review" blocks to this section, or switch "Reviews from" back to Loox.'
          : 'No Loox reviews to show (' + why + '). Check the Loox widget ID in this section\'s settings.'));
        if (arrows) arrows.style.visibility = 'hidden';
        return;
      }
      root.hidden = true;
    };

    /* ---------------- Arrows ---------------- */
    var updateArrows = function () {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (arrows) arrows.style.visibility = max <= 2 ? 'hidden' : '';
    };
    var step = function (dir) {
      var card = track.querySelector('.fb-rv-card');
      track.scrollBy({ left: dir * (card ? card.getBoundingClientRect().width + 16 : track.clientWidth), behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    // "Read more" — one listener for every card, Loox-drawn or hand-picked.
    track.addEventListener('click', function (e) {
      var more = e.target.closest('.fb-rv-more');
      if (!more) return;
      var card = more.closest('.fb-rv-card');
      var open = card.classList.toggle('is-open');
      more.textContent = open ? (d.lessLabel || 'Show less') : (d.moreLabel || 'Read more');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Only offer "Read more" where the clamp actually cut text off.
    var finish = function () {
      track.removeAttribute('aria-busy');
      requestAnimationFrame(function () {
        track.querySelectorAll('.fb-rv-card').forEach(function (card) {
          var t = card.querySelector('.fb-rv-text');
          var m = card.querySelector('.fb-rv-more');
          if (t && m) m.hidden = !(t.scrollHeight > t.clientHeight + 2);
        });
        updateArrows();
      });
    };

    /* ---------------- Hand-picked reviews ----------------
       Already rendered by Liquid from the section's Review blocks; they only
       need their photo frames fitted and the Read more check. */
    if (manual) {
      if (!track.querySelector('.fb-rv-card')) { fail('none added'); return; }
      track.querySelectorAll('.fb-rv-photo').forEach(function (photo) {
        var img = photo.querySelector('img');
        if (img) fitPhoto(photo, img, updateArrows);
      });
      finish();
      return;
    }

    if (!d.looxId || !window.fetch) { fail('missing Loox ID'); return; }

    var url = 'https://loox.io/widget/' + encodeURIComponent(d.looxId) + '/snippets/reviews' +
      '?limit=10&reviewsType=' + (isStore ? 'store-reviews' : 'product-reviews') +
      (d.source === 'product' && d.productId ? '&productId=' + encodeURIComponent(d.productId) : '');

    /* ---------------- Loox cards ---------------- */
    var render = function (reviews) {
      var list = (reviews || []).filter(function (r) {
        return r && r.text && !isVideoReview(r) && (!photosOnly || r.image);
      }).slice(0, limit);
      if (!list.length) { fail('the feed returned none'); return; }

      track.innerHTML = '';
      list.forEach(function (r) {
        var card = el('article', 'fb-rv-card' + (r.image ? '' : ' fb-rv-card--text'));

        if (r.image) {
          var photo = el('div', 'fb-rv-photo');
          var img = document.createElement('img');
          img.src = photoUrl(r.image);
          img.alt = r.altText || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          photo.appendChild(img);
          card.appendChild(photo);
          fitPhoto(photo, img, updateArrows);
        }

        var body = el('div', 'fb-rv-body');
        body.appendChild(stars(Number(r.rating) || 5));
        body.appendChild(el('p', 'fb-rv-text', r.text.trim()));
        var more = el('button', 'fb-rv-more', d.moreLabel || 'Read more');
        more.type = 'button';
        more.hidden = true;
        body.appendChild(more);

        var foot = el('div', 'fb-rv-foot');
        foot.appendChild(el('span', 'fb-rv-name', r.name || ''));
        if (d.verifiedLabel) {
          var v = el('span', 'fb-rv-verified');
          v.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>');
          v.appendChild(document.createTextNode(d.verifiedLabel));
          foot.appendChild(v);
        }
        body.appendChild(foot);

        var prod = productName(r.altText, d.titleTrim);
        if (prod) body.appendChild(el('span', 'fb-rv-product', prod));

        card.appendChild(body);
        track.appendChild(card);
      });
      finish();
    };

    /* ---------------- Fetch (cached per tab session) ---------------- */
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(CACHE_PREFIX + url)); } catch (e) {}
    if (cached) { render(cached); return; }

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { if (!res.ok) throw res.status; return res.json(); })
      .then(function (data) {
        var reviews = data && Array.isArray(data.reviews) ? data.reviews : null;
        if (!reviews) throw 'unexpected response';
        try { sessionStorage.setItem(CACHE_PREFIX + url, JSON.stringify(reviews)); } catch (e) {}
        render(reviews);
      })
      .catch(function (err) { fail(typeof err === 'string' ? err : 'could not reach Loox'); });
  }); }

  initReviews();
  // The theme editor swaps in fresh section HTML whenever a setting or block
  // changes; set the new copy up the same way.
  document.addEventListener('shopify:section:load', initReviews);
})();
